import React from 'react';
import { ConversationType } from '@marageti/z4-sdk/lib/travel';
import { ConversationWithTripDetails } from '@marageti/z4-sdk/lib/travel/Conversation';
import CardView from './inbox-item-card-view';
import { titleCase } from '../../../../utils/helpers';

type InboxItemCardContainerProps = {
  conversation: ConversationWithTripDetails;
  type?: ConversationType.ZicassoToPartner | ConversationType.TravelerToZicasso;
  onDismiss: (tripRequestId: string) => void;
};

const InboxItemCardContainer = ({
  conversation,
  type = ConversationType.TravelerToZicasso,
  onDismiss,
}: InboxItemCardContainerProps) => {
  const {
    id, tripRequestId, tripMatchId, tripMatchStatus, tripRequestStatus, messageState,
  } = conversation;

  const onClearFromQueue = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onDismiss(conversation.id);
  };

  return (
    <CardView
      to={type === ConversationType.ZicassoToPartner ? `/trip-matches/${tripMatchId}/messages/${id}` : `/trip-requests/${tripRequestId}/messages/${id}`}
      status={tripMatchId ? tripMatchStatus : tripRequestStatus}
      type={type}
      partnerName={conversation.partnerName}
      firstUnreadAt={messageState[0].firstUnreadAt}
      onClearFromQueue={onClearFromQueue}
      travelerTags={conversation.travelerTags || []}
      departureDate={conversation.departureDate || ''}
      createdAt={conversation.createdAt || ''}
      tripMessageState={messageState}
      destinations={conversation.destinations?.filter((d) => Boolean(d)).join(', ') || ''}
      travelerName={titleCase(conversation.primaryTravelerName)}
    />
  );
};

export default InboxItemCardContainer;
